// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paypal-container {
  width: 40%;
  margin: auto;

}

.go_back {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.secondary-loader-paypal {
  position: absolute;
  right: 20%;
  top: 45% !important;
}

.pay_pal_page_loader {
  position: absolute;
  z-index: 999;
  background-color: white !important;
  width: 95%;
  height: 95vh;
  top: 1%;
  margin-top: -100px;
  border-radius: 10px;
  background: no-repeat;
}`, "",{"version":3,"sources":["webpack://./src/Components/PayPal/PayPal.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".paypal-container {\n  width: 40%;\n  margin: auto;\n\n}\n\n.go_back {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.secondary-loader-paypal {\n  position: absolute;\n  right: 20%;\n  top: 45% !important;\n}\n\n.pay_pal_page_loader {\n  position: absolute;\n  z-index: 999;\n  background-color: white !important;\n  width: 95%;\n  height: 95vh;\n  top: 1%;\n  margin-top: -100px;\n  border-radius: 10px;\n  background: no-repeat;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
